const state = {
  term: 'Most Popular',
  results: []
}

const getters = {}

const mutations = {
  setTerm (state, term) {
    state.term = term
  },
  setResults (state, results) {
    state.results = results
  },
  concatResults (state, results) {
    state.results.concat(results)
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
